import { useVizFrameworkConfig } from "./config";
/**
 *
 * @returns The analytics client from the VizFrameworkConfigProvider.
 */ export function useAnalytics() {
    const config = useVizFrameworkConfig();
    return config?.analyticsClient;
}

//# sourceMappingURL=analytics.js.map